// Centralized site configuration
export const siteUrl = 'https://www.priceforms.com';

export const geoTargeting: Record<string, { region: string; placename: string }> = {
  cs: { region: 'CZ', placename: 'Prague' },
  sk: { region: 'SK', placename: 'Bratislava' },
  da: { region: 'DK', placename: 'Copenhagen' },
};
